$().ready(() => {
  check_if_has_registered_address();
})

function redirectFromNbnToAdsl(serviceClass, technologyType) {
  // hfc classes
  var serviceClassesUnavailableHfc = ["20"];
  // nbn classes
  var serviceClassesUnavailableNbn = ["0", "4", "10", "30"];
  // fibre classes, this is conditional on the technology type
  var serviceClassesUnavailableFibreConditional = ["3"];
  var technologyTypesUnavailableConditional = ["Copper", "Wireless", "HFC"];

  return false;

  return (
    serviceClassesUnavailableHfc.includes(serviceClass) ||
    serviceClassesUnavailableNbn.includes(serviceClass) ||
    (serviceClassesUnavailableFibreConditional.includes(serviceClass) && technologyTypesUnavailableConditional.includes(technologyType))
  );
}

function getCookie(name) {
  var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  if (match) return match[2];
}

var isIBOPresent = false;
if (typeof getCookie("mate_ref_id") === "string") {
  isIBOPresent = true;
  pushWindowState("ibo", { ibo: getCookie("mate_ref_id") });
}

$().ready(() => {
  if (isIBOPresent) {
    $(".ACN-section").show();
  }
});

var jaiconPresent = false;
if (typeof getCookie("mate_jaicon_id") === "string") {
  jaiconPresent = true;
  pushWindowState("jcon", { jcon: getCookie("mate_jaicon_id") });
}

function check_if_has_registered_address() {
  var address_selected = $(".address-selected"),
    address_results = $(".address-search-results"),
    address_form = $(".address-search"),
    services_banner = $(".services-banner"),
    services_floating = $(".services-floating"),
    services_plans = $(".services-plans"),
    from = $("body").data("from"),
    hasAddress = $(".home .has-address"),
    hasAddressInline = $(".home .has-address.inline"),
    noAddress = $(".home .no-address");

  if (localStorage.getItem("registered_service") != "" && localStorage.getItem("registered_service") !== null) {
    from = localStorage.getItem("registered_service");
  }

  // check if has registered address

  if (localStorage.getItem(from + "_my_registered_address") != "" && localStorage.getItem(from + "_my_registered_address") !== null) {
    var json_data = $.parseJSON(localStorage.getItem(from + "_my_registered_address")),
      json_type = $.parseJSON(localStorage.getItem(from + "_my_registered_address_json")),
      type = json_type.serviceClassInfo.displayName.split("("),
      address = json_data.address ? json_data.address : json_data.fullAddress;

    const classCode = (json_type.serviceClassInfo.classCode ? json_type.serviceClassInfo.classCode : '');
    const classTitle = classCodes[classCode] ? classCodes[classCode].title : '';

    services_banner.hide();

    var service_name = localStorage.getItem("registered_service");
    var service_message = localStorage.getItem(service_name + "_service_message") || service_name + " is available";
    services_floating.find(".title span").text(service_message);

    services_floating.find(".address").html(address);

    services_floating.find(".type").html(classTitle);

    // console.log(json_type.serviceClassInfo.classCode);

    if (redirectFromNbnToAdsl(json_type.serviceClass, json_type.technologyType)) {
      services_floating.find(".title span").html("adsl may be available");
      services_floating.find(".type").html("");
    }

    services_floating.slideDown();
    $(".home.services-floating").addClass("fixed");

    noAddress.hide();

    $(".has-address.title").text(service_message);
    $(".has-address.desc").text(classTitle);
    $(".has-address.address").val(address);
    hasAddress.css({ display: "block" });
    hasAddressInline.attr("style", "display: inline-block !important;");

    setTimeout(function () {
      //			services_plans.css('padding-top', services_floating.outerHeight());
    }, 300);

    if ($("#typeModal").length && from != "nbn") {
      check_if_has_chosen_line();
    }
  }
}

function check_if_has_chosen_line() {
  var from = $("body").data("from"),
    modal = $("#typeModal");

  if (localStorage.getItem(from + "_has_line") == "" || localStorage.getItem(from + "_has_line") === null) {
    setTimeout(function () {
      modal.modal("show");
    }, 600);
  } else {
    var has_line = localStorage.getItem(from + "_has_line");

    $("body").attr("data-line", has_line);
  }
}


const services = {
  "hybrid fibre coaxial": {
    title: "Hybrid Fibre Coaxial (HFC)",
    desc: "Existing ‘pay TV’ or cable network is used to make the final part of the nbn™ connection. Requires an nbn™ HFC network device to be installed in the home.",
  },

  "fibre to the curb": {
    title: "Fibre to the Curb (FTTC)",
    desc: "Fibre is extended close to the home and from here, the existing copper network is used make the final part of the nbn™ connection. Requires an nbn™ FTTC connection box in the home.",
  },

  "fibre to the premises": {
    title: "Fibre to the Premises (FTTP)",
    desc: "Fibre is run from the nearest available fibre node directly to the home. Requires an nbn™ FTTP network device to be installed in the home.",
  },

  "fibre to the node/basement": {
    title: "Fibre to the Node/Building (FTTN/B)",
    desc: "The existing copper phone network from a nearby fibre node is used to make the final part of the nbn™ connection. Requires a VDSL - capable modem.",
  },

  "fixed wireless": {
    title: "Fixed Wireless",
    desc: "Uses data transmitted over radio signals from a transmission tower. Requires installation of an outdoor antenna on the roof, along with a nbn™ connection device inside.",
  },

  "adsl metro": {
    title: "city mates adsl",
    desc: "our city mates adsl plans are available to homes connected to a metro exchange on the Telstra copper network",
  },

  "adsl regional": {
    title: "country mates adsl",
    desc: "our country mates adsl plans are available to homes connected to a regional exchange on the Telstra copper network",
  },

  "fttc-ncd": {
    title: "Fibre to the Curb (FTTC)",
    desc: "Fibre is extended close to the home and from here, the existing copper network is used make the final part of the nbn™ connection. Requires an nbn™ FTTC connection box in the home.",
  },

  "subject to change": {
    title: "nbn™ is available* ",
    desc: "* based on nbn deployment plans and subject to change",
  },
};
window.services = services;

const classCodes = {
  "1": services["fibre to the premises"],
  "2": services["fibre to the premises"],
  "3": services["fibre to the premises"],
  "5": services["fixed wireless"],
  "6": services["fixed wireless"],
  "11": services["fibre to the node/basement"],
  "12": services["fibre to the node/basement"],
  "13": services["fibre to the node/basement"],
  "21": services['hybrid fibre coaxial'],
  "22": services['hybrid fibre coaxial'],
  "23": services['hybrid fibre coaxial'],
  "24": services['hybrid fibre coaxial'],
  "31": services['fibre to the curb'],
  "32": services['fibre to the curb'],
  "33": services['fibre to the curb'],
  "34": services['fibre to the curb'],
}
window.classCodes = classCodes;

const serviceClasses = {
  1: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit will be required.",
  2: "Your nbn™️ service could be connected within 1 - 9 business days.<br /> An nbn™️ technician visit will be required.",
  3: "Your nbn™️ service could be connected within 1 - 3 business days.<br /> No technician visit should be required as nbn™️ equipment should already be installed.",
  5: "Your nbn™️ service could be connected within 1 - 19 business days.<br /> An nbn™️ technician visit will be required.",
  6: "Your nbn™️ service could be connected within 1 - 3 business days.<br /> No technician visit should be required as nbn™️ equipment should already be installed.",
  11: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit will be required.",
  12: "Your nbn™️ service could be connected within 1 - 9 business days.<br /> An nbn™️ technician visit might be required.",
  13: "Your nbn™️ service could be connected within 1 - 3 business days.<br /> No technician visit should be required.",
  21: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit will be required.",
  22: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit will be required.",
  23: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit may be required. In some cases, you may be eligible to perform a self-installation of nbn™️ equipment.",
  24: "Your nbn™️ service could be connected within 1 - 3 business days.<br /> No technician visit should be required as nbn™️ equipment should already be installed.",
  31: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit will be required.",
  32: "Your nbn™️ service could be connected within 1 - 14 business days.<br /> An nbn™️ technician visit will be required.",
  33: "Your nbn™️ service could be connected within 2 - 6 business days.<br /> An nbn™️ technician is not required as you will perform a self-installation of nbn™️ equipment.",
  34: "Your nbn™️ service could be connected within 1 - 3 business days.<br /> No technician visit should be required as nbn™️ equipment should already be installed.",
};
window.serviceClasses = serviceClasses;

$(".modal .type .more-info").on("click", function () {
  var parentsWidth = $(this).parent(".type").outerWidth();

  $(this).find(".box").css("width", parentsWidth);

  $(this).find(".box").fadeToggle();
});

if ($(".home").length) {
  $(window).scroll(function () {
    if ($(this).scrollTop() > parseInt($(".rtms-section").offset().top) - parseInt($(".home.services-floating").outerHeight()) - 250) {
      $(".home.services-floating").css("z-index", "1001").css("opacity", "1");
    } else {
      $(".home.services-floating").css("z-index", "-1").css("opacity", "0");
    }
  });
}
